import React from "react";
/** Styles Import */
import { styled } from "@mui/material/styles";
/** Components Import */
import { Button } from "@mui/material";
import { Input } from "@mui/material";
/** Icons Import */
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import Commons from "../../Services/Common/Common";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function Checking({ datas = [] }) {
  return (
    <div
      className="MuiCondition-scroll"
      style={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: Commons.IsMobile() ? "column" : "row",
        alignItems: Commons.IsMobile() ? "flex-start" : "center",
      }}
    >
      {datas.map((item, index) => {
        const ReturnInputs = () => {
          switch (item.type) {
            case "all":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.gif"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "file":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/*"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "video":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept="video/*"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "image":
              return (
                <img
                  id={item.id}
                  src={item.src}
                  alt="img"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              );
            case "excel":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept=".xls, .xlsx, .cell"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "pdf":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept=".pdf"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "docx":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept=".docx"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            case "hwp":
              return (
                <div>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    {item.buttonName ? item.buttonName : "파일 업로드"}
                    <VisuallyHiddenInput
                      type="file"
                      accept=".hwp, .hwpx"
                      onChange={(e) => item.onChange(e)}
                      onClick={(e) => item.onClick?.(e)}
                    />
                  </Button>
                </div>
              );
            default:
              return (
                <Input
                  disabled={item.disabled}
                  id={item.id}
                  name={item.name}
                  value={item.value}
                  sx={{ mx: 2, ...item.sx }}
                  onChange={(e) => item.onChange(e)}
                  onClick={(e) => item.onClick?.(e)}
                />
              );
          }
        };
        return <div key={index}>{ReturnInputs()}</div>;
      })}
    </div>
  );
}

export default Checking;
